/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Tag from './Tag';
import { tagFetch } from '../../actions/tag';
import { fetchHotWords } from '../../actions/search';
import { trackEventLog } from '../../core/utils'

function getUrlParameter(name) {
  // eslint-disable-next-line no-useless-escape
  const handledName = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${handledName}=([^&#]*)`);
  const results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}


async function action({ store, params }) {
  let ptag = ''
  if (process.env.BROWSER && window.NProgress) {
    ptag = getUrlParameter('ptag');
  }

  trackEventLog(`/w/tag/${params.id}`)
  await store.dispatch(tagFetch(params.id, ptag));
  await store.dispatch(fetchHotWords(params.id))
  if (process.env.BROWSER && window.NProgress) {
    window.NProgress.done()
  }
  return {
    chunks: ['tag'],
    title: `${store.getState().tag.name}-有道精品课-为你精选好课`,
    component: <Tag />,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/tag/index.js